export interface TimingSnapshot {
  playTime: unknown;
  pauseTime: unknown;
}

export interface ValidTimingSnapshot {
  playTime: number;
  pauseTime: number;
}

export function normalizeTiming(snapshot: TimingSnapshot | undefined): ValidTimingSnapshot | undefined {
  if (!snapshot) {
    return undefined;
  }

  const playTime = normalizeFiniteNumber(snapshot.playTime);
  const pauseTime = normalizeFiniteNumber(snapshot.pauseTime);
  if (playTime === undefined || pauseTime === undefined || playTime < 0 || pauseTime < 0) {
    return undefined;
  }

  return { playTime, pauseTime };
}

export function normalizeFiniteNumber(value: unknown): number | undefined {
  if (typeof value === 'string' && value.trim() === '') {
    return undefined;
  }

  if (typeof value !== 'number' && typeof value !== 'string') {
    return undefined;
  }

  const numberValue = Number(value);
  return Number.isFinite(numberValue) ? numberValue : undefined;
}
